const COLOURS = { red: "#C0392B", blue: "#2E6FD8", orange: "#E67E22", yellow: "#E5B800", green: "#3B8C5A" };

export function Dots({ dots = [], size = 12, testid }) {
  return (
    <span className="inline-flex items-center gap-1 shrink-0" data-testid={testid} aria-label={dots.join(" + ")}>
      {dots.map((d) => (
        <span key={d} className="inline-block rounded-full" style={{ width: size, height: size, background: COLOURS[d] }} data-dot={d} />
      ))}
    </span>
  );
}

export default Dots;
